import * as React from 'react';

import {Button} from 'shells/button/button';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
// @ts-expect-error - imported from .js/.jsx file
import {TranscribeIcon} from 'shells/icon/svg/transcribe-icon';
import {Body} from 'shells/typography/body';

import {usePoll} from '../../util/hooks';

import {useGetCallActivity} from '../phone-call/graphql/hooks/use-get-call-activity';

import {useTranscribeActivityCall} from './graphql/hooks/use-transcribe-activity-call';

type Props = {
    activityId: string;
    setHasTranscription: (hasTranscription: boolean) => void;
};

export function CallTranscribeButton(props: Props) {
    const [shouldPoll, setShouldPoll] = React.useState(false);

    const {activity, startPolling, stopPolling} = useGetCallActivity(props.activityId);
    const {transcribeActivityCall, error} = useTranscribeActivityCall(props.activityId);

    const hasTranscription = activity && activity.transcription;

    React.useEffect(() => {
        if (error) {
            setShouldPoll(false);
        }

        if (hasTranscription) {
            setShouldPoll(false);
            // @ts-expect-error
            window.ModalActivity.updateTranscription();
            props.setHasTranscription(true);
        }
    }, [error, shouldPoll, props, hasTranscription]);

    usePoll({shouldPoll, startPolling, stopPolling});

    // need to check for '0' because hasTranscription resolves to 0 as a string
    if (hasTranscription && hasTranscription !== '0') {
        return null;
    }

    return (
        <div className='flex flex-dir-col gap-8'>
            <Button
                variant='ai-blue'
                size='big'
                icon={
                    shouldPoll
                        ? () => <LoadingIcon wrapWithDiv={true} size={15} fill={colors.white} />
                        : TranscribeIcon
                }
                onClick={() => {
                    transcribeActivityCall({activityId: props.activityId});
                    setShouldPoll(true);
                }}
            >
                {shouldPoll ? 'Transcribing…' : 'Transcribe'}
            </Button>
            {(error || (activity && activity.transcriptionStatus === 'ERRORED')) && (
                <Body size='mini' color='error'>
                    Transcription failed
                </Body>
            )}
        </div>
    );
}
